import { API } from 'data';
import { __MergePaginationPage } from 'scripts/paginationQuery';
import { RestAPI } from 'scripts';
import { PaginationType, PostType } from 'types';

export const __MY_ADS_PAGE_SIZE = 18;

export function __FetchMyAds(
    page: number,
    prev?: PaginationType<PostType<'list'>>,
    search?: string,
): Promise<PaginationType<PostType<'list'>>> {
    const params: { page_size: number; page: number; title__icontains?: string } = {
        page_size: __MY_ADS_PAGE_SIZE,
        page,
    };
    if (search) params.title__icontains = search;
    return RestAPI.get<PaginationType<PostType<'list'>>>(API.posts.myPosts, params).then((res) =>
        __MergePaginationPage(page, res.data, prev),
    );
}
